import * as ActionTypes from '../constants/ActionType'

export const removeToken = () => {
  return {
    type: ActionTypes.REMOVE_TOKEN
  }
}
